import { HttpErrorResponse } from "@angular/common/http";

import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import {
  CustomToastrService,
  ToastrMessageType,
  ToastrPosition,
} from 'app/base/services/custom-toast-service';
import { HttpClientService } from "app/services/yoklama/http-client-service";

@Injectable({
  providedIn: 'root'
})
export class ErrorHandler{
  constructor(
    private httpClientService: HttpClientService,
    public alertService: CustomToastrService,
    private router: Router
  ) {}

  public  getServerErrorMessage(error: HttpErrorResponse): any {
    console.log(error)
    switch (error.status) {


      case 400: {
        return this.alertService.message(error.error.detail, 'Başarısız', {

          messageType: ToastrMessageType.Error,
          position: ToastrPosition.TopFullWidth,
        });
      }

      case 401: {

           this.router.navigate(['/login']);
        return this.alertService.message("Oturum süresi doldu. Lütfen tekrar giriş yapın.", 'Başarısız', {

          messageType: ToastrMessageType.Error,
          position: ToastrPosition.TopFullWidth,
        });


      }
      case 403: {
        return this.alertService.message(error.error.detail, 'Başarısız', {
          messageType: ToastrMessageType.Error,
          position: ToastrPosition.TopRight,
        });
      }
      case 500: {
        return this.alertService.message(error.error.detail, 'Başarısız', {
          messageType: ToastrMessageType.Error,
          position: ToastrPosition.TopRight,
        });
      }
      default: {
        return this.alertService.message(error.error.detail, 'Başarısız', {
          messageType: ToastrMessageType.Error,
          position: ToastrPosition.TopRight,
        });
      }
    }
}

}
